import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import OrderBuilderTabContent from "./OrderBuilderTabContent";
import OrderBuilderNavigation from "./OrderBuilderNavigation";

export default class OrderBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active_tab: "products",
      calculating_pricing: false,
      order: {
        status: this.props.order.status || 'completed',
        customer: this.props.order.customer,
        products: this.props.order.products,
      },
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null,
      },
      file_upload_group: this.props.file_upload_group,
      all_products: this.props.all_products,
      products: {},
      new_record: this.props.is_new,
      item_type: this.props.folio_item_type_name || null,
      errors: [],
      currency: {
        id: "USD|$|1",
        name: "United States Dollar",
        iso_code: "USD",
        symbol: "$",
        exchange_rate: 1,
      },
      loading: false,
    };

    this.paymentBuilderRef = React.createRef();

    this.onAddProduct = this.onAddProduct.bind(this);
    this.onRemoveProduct = this.onRemoveProduct.bind(this);
    this.onChangeCustomer = this.onChangeCustomer.bind(this);
    this.onChangeProductQuantity = this.onChangeProductQuantity.bind(this);
    this.onChangeMarkOrderAsCompleted = this.onChangeMarkOrderAsCompleted.bind(this);
    this.onPaymentErrors = this.onPaymentErrors.bind(this);
  }

  render() {    
    return (
      <div className="order-builder">
        <div className="panel panel-form">
          <OrderBuilderNavigation
            step={this.state.active_tab}
            {...this.state}
          />
          <ModalButtons
            loading={this.state.loading}
            buttons={this.navButtons()}
            key="buttons"
          />
          <OrderBuilderTabContent
            {...this.props}
            {...this.state}
            paymentBuilderRef={this.paymentBuilderRef}
            onChangeCustomer={this.onChangeCustomer}
            onAddProduct={this.onAddProduct}
            onRemoveProduct={this.onRemoveProduct}
            onChangeProductQuantity={this.onChangeProductQuantity}
            onChangeMarkOrderAsCompleted={this.onChangeMarkOrderAsCompleted}
            onPaymentErrors={this.onPaymentErrors}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  /*
   * Change handlers
   */

  onAddProduct(product) {
    const { products = {} } = this.state;

    if (!products.hasOwnProperty(product.id)) {
      products[product.id] = [];
    }

    products[product.id].push(product);

    this.setState({ products: products });
  }

  onRemoveProduct(product) {
    const { products = {} } = this.state;
    if (products.hasOwnProperty(product.id)) {
      delete products[product.id];
    }
    this.setState({ products: products });
  }

  onChangeProductQuantity(product, quantity) {
    quantity ||= 1;

    const { products = {} } = this.state;

    if (products.hasOwnProperty(product.id)) {
      products[product.id] = Array.from({ length: quantity }, () => product);
    }

    this.setState({ products: products });
  }

  onChangeCustomer(customer) {
    let order = Object.assign({}, this.state.order);
    if (customer && customer.id) {
      order["customer"] = customer;
    } else {
      order["customer"] = null;
    }
    this.setState({
      order: order,
    });
  }

  onChangeMarkOrderAsCompleted(event) {
    let order = Object.assign({}, this.state.order);
    order["status"] =  event.target.checked ? "completed" : "submitted";

    this.setState({order: order});
  }

  onSave () {    
    this.setState({ loading: true });

    fetch(this.props.order_path, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.prepParams())
    }).then((response) => { return response.json() })
    .then((responseJson) => {
      if (responseJson.errors) {
        this.setState({ errors: responseJson.errors, loading: false }, this.deleteOrder);
      } else {
        this.setState({ order: responseJson }, async () => {
          await this.paymentBuilderRef.current.save(null, this.paymentBuilderRef.current.elements);
        });
      }
    }).catch ((_error) => {
      this.setState({loading: false})
    });
  }

  onPaymentErrors(data) {
    if ((data.errors && data.errors.header_errors.length) || (data.header_errors && data.header_errors.length)) {
      this.deleteOrder();
    }
  }

  deleteOrder() {
    fetch(`${this.props.order_path}/${this.state.order.id}`, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(() => { 
      const { order } = this.state;
      delete order.id
      this.setState({loading: false, order: order})
    }).catch(() => {
      const { order } = this.state;
      delete order.id
      this.setState({loading: false, order: order})
    });
  }

  prepParams() {
    var folio_item_attributes = [];
    Object.entries(this.state.products).map((product) => {
      const { [1]: products } = product;
      products.map((p) => {
        folio_item_attributes.push({
          status: 'pending',
          product_id: p.id,
          total_amount: p.amount,
          item_date: new Date(),
          folio_item_type_id: this.props.folio_item_type_product_id,
          folio_item_source_id: this.props.folio_item_source_id,
        });
      });
    });

    return {
      order: {
        status: this.state.order.status,
        customer_id: this.state.order.customer ? this.state.order.customer.id : null,
        folios_attributes: [
          { 'name': I18n.t('default'),
            folio_items_attributes: folio_item_attributes },
        ],
      },
    };
  }

  navButtons() {
    switch (this.state.active_tab) {
      case "products":
        return [
          {
            name: I18n.t("prev"),
            html_attributes: ["disabled"],
            onClick: (e) => {
              e.preventDefault();
              e.stopPropagation();
            },
          },
          {
            name: I18n.t("next"),
            button_classes: ["primary"],
            onClick: (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.gotoStep("payment");
            },
          },
        ];

      case "payment":
        return [
          {
            name: I18n.t("prev"),
            onClick: (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.gotoStep("products");
            },
          },
          {
            name: I18n.t("submit"),
            button_classes: ["primary"],
            onClick: (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.onSave();
            },
          },
        ];
    }
  }

  gotoStep(step) {
    if (step == "payment" && Object.keys(this.state.products).length == 0) {
      this.setState({ errors: [I18n.t("please_add_products_to_order")] });
      return;
    }

    $(".modal-body").scrollTop(0);
    this.setState({ errors: [], active_tab: step, loading: false }, () => {
      if (this.state.active_tab == "payment") {
        this.calculatePricing();
      }
    });
  }

  calculatePricing() {
    this.setState({ calculating_pricing: true });

    $.ajax({
      type: "POST",
      url: this.props.calulate_pricing_path,
      data: this.prepParams(),
    }).done((data) => {
      this.setState({calculating_pricing: false, order: data})
    })
  }
}
